import styled from 'styled-components';

interface ContainerProps {
  $selected: boolean;
  $selectable: boolean;
  $visualizado: boolean;
}

export const Container = styled.div<ContainerProps>`
  position: relative;
  padding: 15px;
  border-radius: 10px;
  border: 2px solid
    ${({ $selected, $visualizado }) => {
      if ($selected) {
        return 'var(--primary)';
      }

      if ($visualizado) {
        return '#d0dad7';
      }

      return '#c8ded8';
    }};
  background: ${({ $selected, $visualizado }) => {
    if ($selected) {
      return '#dff4f0';
    }

    if ($visualizado) {
      return '#edf1ef';
    }

    return '#eef7f4';
  }};
  box-shadow: ${({ $selected }) =>
    $selected
      ? '0 10px 24px rgba(0, 116, 103, 0.16)'
      : '0 8px 18px rgba(0, 116, 103, 0.09)'};
  cursor: ${({ $selectable }) => ($selectable ? 'pointer' : 'default')};
  margin-bottom: 10px;
  transition:
    border-color 0.2s,
    background-color 0.2s,
    box-shadow 0.2s,
    transform 0.2s;

  &:hover {
    transform: ${({ $selectable }) =>
      $selectable ? 'translateY(-2px)' : 'none'};
    box-shadow: ${({ $selectable }) =>
      $selectable
        ? '0 12px 26px rgba(0, 116, 103, 0.14)'
        : '0 8px 18px rgba(0, 116, 103, 0.09)'};
  }

  &:active {
    transform: ${({ $selectable }) =>
      $selectable ? 'translateY(-1px) scale(0.995)' : 'none'};
  }
`;
interface NomePacienteProps {
  visualizado: boolean;
}
export const NomePaciente = styled.h1<NomePacienteProps>`
  color: ${({ visualizado }) => (visualizado ? '#56615f' : 'var(--primary)')};
  font-size: 16px;
  font-weight: 700;
  line-height: 1.25;
  margin-bottom: 10px;
`;
export const Info = styled.h1`
  color: #263a36;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.35;
`;

export const StatusConcluido = styled.div`
  margin-top: 5%;
  width: 45%;
  height: 15;
  background-color: #cfebe4;
  color: #005f56;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  border: 1px solid #95d0c5;
`;
export const StatusAguardando = styled.div`
  margin-top: 5%;
  width: 60%;
  background-color: #f9e3e8;
  color: #8d1f35;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  border: 1px solid #efafbc;
`;

export const TextStatus = styled.p`
  font-size: 14px;
  font-weight: 700;
  color: inherit;
`;

export const Row = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const Actions = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;

export const AcessosButton = styled.button`
  width: 40px;
  height: 40px;
  border-radius: 20px;
  border: none;
  background: var(--primary);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition:
    background-color 0.2s,
    transform 0.2s;

  &:hover {
    background: #005f56;
    transform: translateY(-1px);
  }

  &:active {
    transform: scale(0.98);
  }
`;

export const Button = styled.button`
  width: 72px;
  height: 60px;
  background: #dcefea;
  border: 1px solid #b9d9d2;
  border-radius: 8px;
  cursor: pointer;
  transition:
    background-color 0.2s,
    border-color 0.2s,
    opacity 0.2s,
    transform 0.2s;

  &:hover:not(:disabled) {
    background: #cce8e2;
    border-color: #8fc9bd;
    transform: translateY(-1px);
  }

  &:active:not(:disabled) {
    transform: scale(0.98);
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.45;
  }
`;

export const Photo = styled.img`
  width: 100%;
  height: 40px;
  border-radius: 10px;
  object-fit: contain;
`;

export const Infos = styled.div`
  flex: 1;
  padding-right: 8px;
`;
